var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { flexRender } from '@tanstack/react-table';
import { getIcon } from "./TableElements";






/* eslint-disable comma-spacing */
const TableHeader = ({ headerGroup, draggableRows, sortedChanged }) => /*#__PURE__*/
_jsx("tr", { className: "border-b" }, void 0,
headerGroup.headers.map((header) => {var _header$column$column, _header$column$column2, _header$column$column3;
  const isSortable = header.column.getCanSort();
  const isSelect = header.column.id === 'checkbox-select';
  const commonHeaderClassName = `${draggableRows ? 'pl-7' : ''} ${
  isSelect ? 'px-2 py-3' : 'px-6 py-3'
  }`;

  const headerClassName = `${!((_header$column$column = header.column.columnDef.meta) !== null && _header$column$column !== void 0 && (_header$column$column2 = _header$column$column.headerClassName) !== null && _header$column$column2 !== void 0 && _header$column$column2.includes('invisible')) ? commonHeaderClassName : ''} ${((_header$column$column3 = header.column.columnDef.meta) === null || _header$column$column3 === void 0 ? void 0 : _header$column$column3.headerClassName) || ''}`;

  return /*#__PURE__*/(
    _jsx("th", { scope: "col", className: headerClassName }, header.id, /*#__PURE__*/
    _jsx("div", {
      className: `inline-flex ${isSortable ? 'cursor-pointer select-none' : ''}`,
      onClick: header.column.getToggleSortingHandler() }, void 0,

    flexRender(header.column.columnDef.header, header.getContext()),
    isSortable && getIcon(header, sortedChanged)
    )
    ));

})
);


export { TableHeader };